
export interface UpdateLastMessageRequest {
  lastMessage: string;
  lastMessageTime: string;
}
